import React from 'react';

import { BackButton, ScreenContainer, ScreenHeader, SeeTheJourneyButton } from 'ui/component';
import { DetailCircleWithButtons } from '../../component';
import { useNavigationContext } from '../../context';
import classNames from './EABDKeyToSuccessScreen.module.scss';

export const KeyToSuccessScreen = React.memo(() => {
  const { pop, push, reset } = useNavigationContext();

  const OnHomeButtonPressCallback = React.useCallback(() => reset(), [reset]);
  const OnBackButtonPressCallback = React.useCallback(() => pop(), [pop]);
  const OnSeeTheJourneyButtonPressCallback = React.useCallback(() => push('journey'), [push]);

  const FooterElement = React.useMemo(() => {
    return (
      <footer className={classNames.footer}>
        <BackButton text={'Back'} onPress={OnBackButtonPressCallback} />
        <SeeTheJourneyButton text={'See the journey'} onPress={OnSeeTheJourneyButtonPressCallback} />
      </footer>
    );
  }, [OnBackButtonPressCallback, OnSeeTheJourneyButtonPressCallback]);

  return (
    <ScreenContainer>
      <ScreenHeader shouldShowHome={true} onHomePress={OnHomeButtonPressCallback} />
      <div className={classNames.content}>
        <DetailCircleWithButtons />
      </div>
      {FooterElement}
    </ScreenContainer>
  );
});
